export default "__VITE_ASSET__f9b4c1e2__"